import React from "react";

export default function PatientScansPage(): React.ReactElement {
  return (
    <>
      <h1>Patient Scans</h1>
    </>
  );
}
